require('./release/angular-recaptcha.js');
module.exports = 'vcRecaptcha';



//////////////////
// WEBPACK FOOTER
// ./~/angular-recaptcha/index.js
// module id = 1110
// module chunks = 1